module.exports = __webpack_public_path__ + "media/img/pages/companies/covance_new-b91b9c59abb1cd66231c8b95fdc51ce3.jpg";